import React from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { HiOutlineChevronDoubleLeft } from 'react-icons/hi';
import cn from 'classnames';
import _ from 'underscore';

import { Page, Form, Select, Button } from 'ui/components';
import { Booking, Tracking } from 'services/action';

import { formatDate } from 'utilities/common';
import { FaCheckSquare, FaPlus } from 'react-icons/fa';
import CustomerForm from 'ui/screens/authorized/master/customer/component/form';

const CreateBlanko = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);
  const Session = useSelector((state) => state.Auth?.session);

  const [tracking, setTracking] = React.useState('');
  const [refCode, setRefCode] = React.useState('');
  const [service, setService] = React.useState('');
  const [serviceType, setServiceType] = React.useState('');
  const [gtv, setGtv] = React.useState();

  const [customer, setCustomer] = React.useState(null);
  const [createCustomer, setCreateCustomer] = React.useState(false);

  const [recipient, setRecipient] = React.useState();
  const [recipientName, setRecipientName] = React.useState('');
  const [recipientCp, setRecipientCp] = React.useState('');
  const [recipientPh, setRecipientPh] = React.useState('');
  const [recipientAddress, setRecipientAddress] = React.useState('');
  const [personal, setPersonal] = React.useState(false);
  const [village, setVillage] = React.useState('');

  const [items, setItems] = React.useState();

  const [activated, setActivated] = React.useState(false);
  const [setting, setSetting] = React.useState(null);

  const $handleSubmit = async (e) => {
    let re = null;
    let item = null;

    if (
      recipientName ||
      recipientCp ||
      recipientPh ||
      village ||
      recipientAddress
    ) {
      re = {
        name: recipientName,
        contact_person: recipientCp,
        phone_number: recipientPh,
        village_id: village?.village_id,
        address: recipientAddress,
      };
    }

    if (recipient) {
      re.id = recipient?.id;
    }

    if (items?.name || items?.quantity || items?.weight) {
      item = [
        {
          item_name: items?.name,
          quantity: parseFloat(items?.quantity),
          weight: parseFloat(items?.weight),
          long: items?.long ? parseFloat(items?.long) : null,
          Wide: items?.Wide ? parseFloat(items?.Wide) : null,
          high: items?.high ? parseFloat(items?.high) : null,
          metric: items?.metric ? parseFloat(items?.metric) : null,
        },
      ];
    }

    const payload = {
      customer_id: customer?.id,
      schedule_at: formatDate(new Date(), 'YYYY-MM-DD'),
      hub_id: Session?.hub?.id,
      service_type_id: service ? serviceType?.id : null,
      shipments: [
        {
          gtv: parseFloat(gtv || 0),
          tracking_code: tracking,
          ref_code: refCode,
          recipient: re,
          items: item,
          service_type_id: service ? serviceType?.id : null,
        },
      ],
    };

    const x = await Dispatch(Booking.$create(payload));
    if (x?.message === 'success') {
      History.replace(`/shipment`);
    }
  };

  const $checkCode = async (e) => {
    const c = await Dispatch(Tracking?.$get(e));

    if (c?.message === 'success' && c?.data) {
      setActivated(true);
    }
  };

  const handleCustomer = async (c) => {
    setCustomer(c);
    setRecipient(null);
  };

  const $handleChecked = async (e) => {
    if (e === true) {
      setRecipientCp(recipientName);
      setPersonal(true);
    } else {
      setRecipientCp('');
      setPersonal(false);
    }
  };

  const $getPriviledge = async () => {
    const payload = {};

    const findSender = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location.sender',
    });

    const findRecipient = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location.recipient',
    });

    const findCustomer = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.partner',
    });

    if (findSender) {
      payload.sender = findSender;
    }

    if (findRecipient) {
      payload.recipient = findRecipient;
    }

    if (findCustomer) {
      payload.customer = findCustomer;
    }

    setSetting(payload);
  };

  React.useEffect(() => {
    if (Session?.privileges) {
      const x = _.findWhere(Session?.privileges, {
        service: 'nvo.tms.shipment',
      });

      if (x) {
        if (x?.action === 'read_only') {
          History.push('/');
        }
      } else {
        History.push('/');
      }
    }
  }, [Session]);

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  React.useEffect(() => {
    setTracking(match?.params?.id);
    $checkCode(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (items?.long && items?.Wide && items?.high && items?.quantity) {
      const m =
        ((parseFloat(items?.long) *
          parseFloat(items?.Wide) *
          parseFloat(items?.high)) /
          serviceType?.dividers);

      setItems({ ...items, metric: m?.toFixed(2) });
    } else {
      setItems({ ...items, metric: null });
    }
  }, [
    items?.long,
    items?.Wide,
    items?.high,
    items?.quantity,
    serviceType?.dividers,
  ]);

  if (activated) {
    return (
      <Page
        type="form"
        className={'col-lg-8 col-md-10 bordered'}
        onSubmit={$handleSubmit}
      >
        <Page.Body className="padding bordered d-flex flex-column justify-content-center align-items-center">
          <div className="fs-4 fw-semibold">Whoops !</div>
          <div>This blanko has been activated</div>
          <button
            className="mt-3 btn btn-primary"
            onClick={() => History.replace('/')}
          >
            Go Back
          </button>
        </Page.Body>
      </Page>
    );
  }

  return (
    <Page
      type="form"
      className={'col-lg-8 col-md-10 bordered'}
      onSubmit={$handleSubmit}
    >
      <Page.Header
        pretitle="Aktifasi"
        title={
          <div className="d-flex align-items-center">
            <span className="page-title">Shipment - {match?.params?.id}</span>
          </div>
        }
      >
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={`tooltip-top`}>Kembali</Tooltip>}
        >
          <Link
            to={`/`}
            onClick={() => Dispatch(Booking.$reset())}
            className="btn btn-secondary px-2"
          >
            <HiOutlineChevronDoubleLeft size="17" />
          </Link>
        </OverlayTrigger>
      </Page.Header>

      <Page.Body className="padding bordered">
        <div className="row m-0">
          <div className="col-md-6">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Detil Informasi
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label ">Pilih Customer</label>
                  <div className="row align-items-top">
                    <div
                      className={cn(
                        !Session?.privileges ||
                          setting?.customer?.action === 'manage'
                          ? 'col-10 pe-0'
                          : 'col-12 pe-0'
                      )}
                    >
                      <Select.Remote
                        label=""
                        placeholder=""
                        url="/partner"
                        params={{'type': 'customer'}}
                        value={customer}
                        initialValue={customer?.id}
                        key={customer?.id}
                        row={(d) => {
                          return { value: d.id, label: d.name };
                        }}
                        onSelected={(c) => {
                          handleCustomer(c);
                        }}
                        errors={StateForm?.errors?.customer_id}
                      />
                    </div>
                    {!Session?.privileges ||
                      setting?.customer?.action === 'manage' ? (
                      <div className="col-2 ps-0 text-end">
                        <button
                          type="button"
                          className="btn btn-primary rounded p-2 "
                          style={{ minHeight: 36, minWidth: '80%' }}
                          onClick={() => setCreateCustomer(true)}
                          disabled={customer}
                        >
                          <FaPlus />
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <Form.Input
                  label="Kode Ref"
                  type="text"
                  value={refCode || ''}
                  onChange={(e) => setRefCode(e.target.value)}
                  error={StateForm?.errors?.ref_code}
                />
              </div>

              <div className="col-6">
                <div className="mb-3">
                  <Select.Remote
                    label="Pilih Layanan"
                    isSearch={false}
                    placeholder=""
                    url="/tms/service"
                    value={service?.id}
                    row={(d) => {
                      return {
                        value: d.id,
                        label: d.name,
                      };
                    }}
                    onSelected={(c) => {
                      setService(c);
                      setServiceType(null);
                    }}
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="mb-3">
                  <Select.Remote
                    label="Pilih Tipe Layanan"
                    isSearch={false}
                    placeholder=""
                    url="/tms/service/type"
                    params={{ service_id: service?.id }}
                    value={serviceType?.id}
                    row={(d) => {
                      return {
                        value: d.id,
                        label: d.name,
                      };
                    }}
                    onSelected={(c) => {
                      setServiceType(c);
                    }}
                    disabled={!service}
                    keys={service?.id}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <Form.Input
                  label="Nilai Barang"
                  type="number"
                  value={gtv}
                  onChange={(e) => {
                    setGtv(e.target.valueNumber);
                  }}
                />
              </div>
            </div>

            <div className="hr-text hr-text-left text-primary mb-3 mt-md-4 mt-4">
              Detil Item
            </div>
            <Form.Input
              required={
                items?.name ||
                  items?.quantity ||
                  items?.weight ||
                  items?.long ||
                  items?.wide ||
                  items?.high
                  ? true
                  : false
              }
              label="Nama Item"
              type="text"
              value={items?.name || ''}
              onChange={(e) => setItems({ ...items, name: e.target.value })}
              error={StateForm?.errors['shipments.0.items.0.item_name']}
            />
            <div className="row">
              <div className="col-6">
                <Form.Input
                  required={
                    items?.name ||
                      items?.quantity ||
                      items?.weight ||
                      items?.long ||
                      items?.Wide ||
                      items?.high
                      ? true
                      : false
                  }
                  label="Koli"
                  type="text"
                  value={items?.quantity || ''}
                  onChange={(e) =>
                    setItems({ ...items, quantity: e.target.value })
                  }
                  error={StateForm?.errors['shipments.0.items.0.quantity']}
                />
              </div>

              <div className="col-6">
                <Form.Input
                  required={
                    items?.name ||
                      items?.quantity ||
                      items?.weight ||
                      items?.long ||
                      items?.Wide ||
                      items?.high
                      ? true
                      : false
                  }
                  label="Berat (Kg)"
                  type="text"
                  value={items?.weight || ''}
                  onChange={(e) =>
                    setItems({ ...items, weight: e.target.value })
                  }
                  error={StateForm?.errors['shipments.0.items.0.weight']}
                />
              </div>

              {service && serviceType?.pricing_schema === 'weight_based' ? (
                <>
                  {/* metric */}
                  <div className="col-md-6">
                    <Form.Input
                      required={
                        items?.long || items?.Wide || items?.high ? true : false
                      }
                      autoComplete="off"
                      label="Panjang (cm)"
                      name="long"
                      type="text"
                      value={items?.long || ''}
                      onChange={(e) => {
                        setItems({ ...items, long: e.target.value });
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <Form.Input
                      required={
                        items?.long || items?.Wide || items?.high ? true : false
                      }
                      autoComplete="off"
                      label="Lebar (cm)"
                      name="Wide"
                      type="text"
                      value={items?.Wide || ''}
                      onChange={(e) => {
                        setItems({ ...items, Wide: e.target.value });
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <Form.Input
                      required={
                        items?.long || items?.Wide || items?.high ? true : false
                      }
                      autoComplete="off"
                      label="Tinggi (cm)"
                      name="high"
                      type="text"
                      value={items?.high || ''}
                      onChange={(e) => {
                        setItems({ ...items, high: e.target.value });
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <Form.Input
                      required={
                        items?.long || items?.Wide || items?.high ? true : false
                      }
                      disabled
                      pattern="[0-9]{0,50}"
                      autoComplete="off"
                      label="Volumetrik (Kg)"
                      name="metric"
                      type="text"
                      value={items?.metric}
                    />
                  </div>
                </>
              ) : null}
            </div>
          </div>

          <div className="col-md-6">
            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
              Penerima
            </div>
            <div className="mb-3">
              <Select.Remote.Createable
                label="Pilih"
                placeholder=""
                url="/location/recipient"
                params={{ customer_id: customer?.id, type: 'recipient' }}
                errors={StateForm?.errors['shipments.0.recipient']}
                keys={customer?.id}
                disabled={!customer}
                value={recipient}
                row={(d) => {
                  return { value: d.id, label: d.name };
                }}
                onSelected={(c) => {
                  if (c) {
                    setRecipient(c);
                    setRecipientName(c?.name);
                    setRecipientCp(c?.contact_person);
                    setRecipientPh(c?.phone_number);
                    setRecipientAddress(c?.address);
                    setVillage(c?.region);

                    if (c?.name === c?.contact_person) {
                      setPersonal(true);
                    }
                  } else {
                    setRecipient(null);
                    setRecipientName(null);
                    setRecipientCp(null);
                    setRecipientPh(null);
                    setRecipientAddress(null);
                    setVillage(null);
                    setPersonal(false);
                  }
                }}
              />

              {StateForm?.errors['shipments.0.recipient'] ? (
                <div
                  className="invalid-feedback mt-n1"
                  style={{ display: 'block' }}
                >
                  {StateForm?.errors['shipments.0.recipient']}
                </div>
              ) : null}
            </div>

            {!recipient?.id ? (
              <div className="hr-text hr-text text-primary mb-3 mt-md-4 mt-4">
                atau buat baru
              </div>
            ) : (
              <div className="hr-text hr-text text-primary mb-3 mt-md-4 mt-4">
                Data Penerima
              </div>
            )}

            <div className="mb-3">
              <Form.Input
                required={
                  recipientName ||
                    recipientCp ||
                    recipientPh ||
                    village ||
                    recipientAddress
                    ? true
                    : false
                }
                value={recipientName || ''}
                onChange={(e) => setRecipientName(e.target.value)}
                type="text"
                label="Nama"
                hint={
                  <span
                    className={cn('d-flex align-items-center cursor-pointer')}
                    onClick={() => $handleChecked(!personal)}
                  >
                    <FaCheckSquare
                      color={personal ? '#2f83ba' : '#ddd'}
                      size={18}
                      className="me-2"
                    />{' '}
                    alamat personal
                  </span>
                }
                error={StateForm?.errors['shipments.0.recipient.name']}
              />

              {personal ? null : (
                <Form.Input
                  required={
                    recipientName ||
                      recipientCp ||
                      recipientPh ||
                      village ||
                      recipientAddress
                      ? true
                      : false
                  }
                  value={recipientCp || ''}
                  onChange={(e) => setRecipientCp(e.target.value)}
                  type="text"
                  label="Kontak Person"
                  error={
                    StateForm?.errors['shipments.0.recipient.contact_person']
                  }
                />
              )}

              <Form.Input
                value={recipientPh || ''}
                required={
                  recipientName ||
                    recipientCp ||
                    recipientPh ||
                    village ||
                    recipientAddress
                    ? true
                    : false
                }
                onChange={(e) => setRecipientPh(e.target.value)}
                type="phone"
                label="Nomor Hp"
                error={StateForm?.errors['shipments.0.recipient.phone_number']}
              />

              <div className="mb-3">
                <Select.Remote
                  required={
                    recipientName ||
                      recipientCp ||
                      recipientPh ||
                      village ||
                      recipientAddress
                      ? true
                      : false
                  }
                  initialValue={village?.village_id}
                  params={{
                    search: recipient ? recipient?.region?.postal_code : null,
                  }}
                  key={recipient?.id}
                  label="Pilih Wilayah"
                  placeholder=""
                  url="/region"
                  row={(d) => {
                    return {
                      value: d?.village_id,
                      label: `${d?.village_name}, ${d?.district_name}, ${d?.regency_name}, ${d?.province_name} ${d?.postal_code} `,
                    };
                  }}
                  onSelected={(c) => {
                    setVillage(c);
                  }}
                  hint="cari berdasarkan kecamatan/kabupaten/kota/provinsi/kode pos. e.g: 44152"
                  errors={StateForm?.errors['shipments.0.recipient.village']}
                />
              </div>

              <Form.Textbox
                required={
                  recipientName ||
                    recipientCp ||
                    recipientPh ||
                    village ||
                    recipientAddress
                    ? true
                    : false
                }
                value={recipientAddress || ''}
                onChange={(e) => setRecipientAddress(e.target.value)}
                rows={4}
                label="Alamat Lengkap"
                error={StateForm?.errors['shipments.0.recipient.address']}
              />
            </div>
          </div>
        </div>

        <Modal
          show={createCustomer}
          onHide={() => setCreateCustomer(false)}
          backdrop="static"
          centered
          size="md"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Buat Customer</Modal.Title>
          </Modal.Header>
          <CustomerForm
            onClose={(e) => {
              setCustomer(e);
              setCreateCustomer(false);
            }}
            selected
          />
        </Modal>
      </Page.Body>

      <Page.Footer className="justify-content-center gap-2 pt-3 border-top mt-5 d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary px-4 py-3"
          onClick={() => {
            Dispatch(Booking.$reset());
            History.replace(`/`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary px-4 py-3"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateBlanko;
